import { Component } from 'react';
import { connect } from 'react-redux';

import Icon from 'components/atoms/Icon';
import { bindActionCreators, Dispatch } from 'redux';
import {
    SetErrorHandlerAction,
    setErrorHandlerAction,
    ShowMessageAction,
    showMessageAction,
} from 'store/actions/errorsActions';
import { SetLayoutAction, setLayoutAction } from 'store/actions/layoutActions';
import {
    InterfaceVariablesType,
    Layout,
    OpenModal,
    PilotagePlanSettingType,
    PlanType,
    PortType,
    RootState,
    SwitchType,
    TransitType,
    UserType,
} from 'types';
import {
    MainControlsInterface,
    MapControlsInterface,
    MenuControlsInterface,
    ProfileControlsInterface,
} from 'types/functions';
import { checkDifferent, getMode } from 'utils/formHandlers';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

import { DRAWING_MODES, TIME_MODE_RANG_HOURS } from 'data/static';
import { Tooltip } from 'react-tooltip';
import { savedScreensCreate } from 'services/savedScreens';
import { FilterObjectType } from 'types/search';
import { SystemType } from 'types/system';
import copyToClipboard from 'utils/clipboard';
import { hasPermission } from 'utils/permission';
import StateIcon from './StateIcon';

interface ToolBarProps {
    layout: Layout;
    switchs: SwitchType;
    port: PortType;
    profileControls: ProfileControlsInterface;
    mapControls: MapControlsInterface;
    mainControls: MainControlsInterface;
    searchObject: FilterObjectType;
    highlightObject: FilterObjectType;
    setLayoutAction: SetLayoutAction;
    openModelFunction: OpenModal;
    showMessageAction: ShowMessageAction;
    menuControls: MenuControlsInterface;
    system: SystemType;
    setErrorHandlerAction: SetErrorHandlerAction;
    mode: string;
    user: UserType;
    pilotagePlans: PlanType[];
    pilotagePlanSettings: PilotagePlanSettingType;
    outlineInterval: number;
    interfaceVariables: InterfaceVariablesType;
}

interface ToolBarState {
    layout: Layout;

    //unused state
    // plans: PlanType[];

    port: PortType | null;

    transit: TransitType | null;
    chartToolsMenu: boolean;
    timeToolsMenu: boolean;
    playbackToolsMenu: boolean;
    earseChartMenu: boolean;
    earseTimeMenu: boolean;
    earsePlaybackMenu: boolean;
    chartChartDisplayMenu: boolean;
    timeChartDisplayMenu: boolean;
    playbackChartDisplayMenu: boolean;
}

class ToolBar extends Component<ToolBarProps, ToolBarState> {
    constructor(props: ToolBarProps) {
        super(props);
        this.state = {
            layout: props.layout,

            // plans: props.port.meta_data.pilotagePlans.plans || [],
            port: props.port,

            transit: null,
            chartToolsMenu: false,
            timeToolsMenu: false,
            playbackToolsMenu: false,
            earseChartMenu: false,
            earseTimeMenu: false,
            earsePlaybackMenu: false,
            chartChartDisplayMenu: false,
            timeChartDisplayMenu: false,
            playbackChartDisplayMenu: false,
        };
    }

    static getDerivedStateFromProps(props: ToolBarProps, state: ToolBarState) {
        if (checkDifferent(props.layout, state.layout) || checkDifferent(props.port, state.port)) {
            return {
                layout: props.layout,
            };
        }

        return null;
    }

    refreshLayout = () => {
        this.setState({
            //@ts-ignore
            layout: {},
        });
    };

    addTagsAndComments = () => {
        if (!this.state.layout.sections.grid.tools.tagsGrid.state) {
            return;
        }

        const { transits } = this.props.mainControls.getTransit(0);
        if (
            !transits.filter((x) => {
                return x.options.select;
            }).length
        ) {
            this.props.showMessageAction({
                messageType: 'WARN',
                message: translate('No transits selected.'),
            });

            return false;
        }

        this.props.openModelFunction(
            'allTransitTagsAndCommentsModel',
            0,
            'medium',
            {},
            {
                onCancel: () => {
                    this.props.openModelFunction('allTransitTagsAndCommentsModel');
                },
                onConfirm: () => {
                    //console.log('saved');
                },
            },
            true
        );
    };

    saveSearch = () => {
        this.props.openModelFunction(
            'saveSearchModel',
            0,
            'medium',
            {},
            {
                onCancel: () => {
                    this.props.openModelFunction('saveSearchModel');
                },
            },
            true
        );
    };

    playbackTransit = () => {
        // const { selectedTransit, selectedTime } = this.props.mainControls.getSelectedTranist();
        // if (!selectedTransit) {
        //     window?.log('ERROR : Invalid transit data', 'color: red');
        //     return;
        // }
        this.props.mainControls.playbackTransit(
            //@ts-ignore
            this.state.layout.inspectTransit,
            this.state.layout.inspectSelectedTime
        );
    };

    transitDownloadSweptPathFile = () => {
        const selectedTransit = this.props.layout.inspectTransit;
        if (!selectedTransit) {
            window?.log('ERROR : Invalid transit data', 'color: red');
            return;
        }
        this.props.mainControls.transitDownloadSweptPathFile(selectedTransit);
    };

    downloadTransit = () => {
        const selectedTransit = this.props.layout.inspectTransit;
        const { transit } = this.props.mainControls.getTransit(selectedTransit);
        if (!selectedTransit) {
            window?.log('ERROR : Invalid transit data', 'color: red');
            return;
        }
        this.props.mainControls.transitExportFile(transit);
    };

    editTransit = () => {
        const selectedTransit = this.props.layout.inspectTransit;
        this.props.openModelFunction(
            'editTransitModel',
            0,
            'auto',
            { id: selectedTransit },
            {
                onCancel: () => {
                    this.props.openModelFunction('editTransitModel');
                },
                onConfirm: () => {
                    //console.log('saved');
                },
            },
            true
        );
    };

    highlightTransit = () => {
        const selectedTransit = this.props.layout.inspectTransit;
        const { transit } = this.props.mainControls.getTransit(selectedTransit);
        this.props.mainControls.updatehighlight(transit?.id || 0, !transit?.options.highlight);
    };

    updateDrawTrack = () => {
        const selectedTransit = this.props.layout.inspectTransit;
        const { transit } = this.props.mainControls.getTransit(selectedTransit);
        this.props.mainControls.updateDrawTrack(transit?.id || 0, !transit?.options.drawTrack);
    };

    updateDrawVesselOutline = () => {
        const selectedTransit = this.props.layout.inspectTransit;
        const { transit } = this.props.mainControls.getTransit(selectedTransit);
        this.props.mainControls.updateDrawVesselOutline(transit?.id || 0, !transit?.options.outline);
    };

    transitTagsAndComments = () => {
        const selectedTransit = this.props.layout.inspectTransit;
        this.props.openModelFunction(
            'transitTagsAndCommentsModel',
            0,
            'medium',
            { tab: 'tags', id: selectedTransit },
            {
                onCancel: () => {
                    this.props.openModelFunction('transitTagsAndCommentsModel');
                },
                onConfirm: () => {
                    //console.log('saved');
                },
            },
            true
        );
    };

    renderIcon = (x, menu) => {
        switch (x) {
            case 'loadFavourit':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572" />
                    </Icon>
                );
            case 'saveFavourit':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2" />
                        <path d="M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                        <path d="M14 4l0 4l-6 0l0 -4" />
                    </Icon>
                );
            case 'transitDownloadSweptPathFile':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                        <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                        <path d="M12 17v-6" />
                        <path d="M9.5 14.5l2.5 2.5l2.5 -2.5" />
                    </Icon>
                );
            case 'showAllTransits':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                        <path d="M11.102 17.957c-3.204 -.307 -5.904 -2.294 -8.102 -5.957c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6a19.5 19.5 0 0 1 -.663 1.032"></path>
                        <path d="M15 19l2 2l4 -4"></path>
                    </Icon>
                );
            case 'transitTagsAndComments':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                        <path d="M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z"></path>
                    </Icon>
                );
            case 'editTransit':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"></path>
                        <path d="M13.5 6.5l4 4"></path>
                        <path d="M16 19h6"></path>
                    </Icon>
                );
            case 'updateDrawVesselOutline':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M3 6m0 6a6 6 0 0 1 6 -6h6a6 6 0 0 1 6 6v0a6 6 0 0 1 -6 6h-6a6 6 0 0 1 -6 -6z" />
                    </Icon>
                );
            case 'updateDrawTrack':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M4 16l6 -7l5 5l5 -6"></path>
                        <path d="M15 14m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                        <path d="M10 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                        <path d="M4 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                        <path d="M20 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                    </Icon>
                );
            case 'highlightTransit':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M17.286 21.09q -1.69 .001 -5.288 -2.615q -3.596 2.617 -5.288 2.616q -2.726 0 -.495 -6.8q -9.389 -6.775 2.135 -6.775h.076q 1.785 -5.516 3.574 -5.516q 1.785 0 3.574 5.516h.076q 11.525 0 2.133 6.774q 2.23 6.802 -.497 6.8"></path>
                    </Icon>
                );
            case 'downloadTransit':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4"></path>
                        <path d="M12 13l0 9"></path>
                        <path d="M9 19l3 3l3 -3"></path>
                    </Icon>
                );
            case 'inspectTransit':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M3 12l3 0" />
                        <path d="M12 3l0 3" />
                        <path d="M7.8 7.8l-2.2 -2.2" />
                        <path d="M16.2 7.8l2.2 -2.2" />
                        <path d="M7.8 16.2l-2.2 2.2" />
                        <path d="M12 12l9 3l-4 2l-2 4l-3 -9" />
                    </Icon>
                );
            case 'playbackTransit':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3"></path>
                        <path d="M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3"></path>
                    </Icon>
                );
            case 'inspectTransitMenu':
                return (
                    <Icon
                        className={twclsx(
                            'w-6',
                            'h-6',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M7 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                        <path d="M17 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                        <path d="M16.346 9.17l-.729 -1.261c-.16 -.248 -1.056 -.203 -1.117 .091l-.177 1.38" />
                        <path d="M19.761 14.813l-2.84 -5.133c-.189 -.31 -.592 -.68 -1.421 -.68c-.828 0 -1.5 .448 -1.5 1v6" />
                        <path d="M7.654 9.17l.729 -1.261c.16 -.249 1.056 -.203 1.117 .091l.177 1.38" />
                        <path d="M4.239 14.813l2.84 -5.133c.189 -.31 .592 -.68 1.421 -.68c.828 0 1.5 .448 1.5 1v6" />
                        <rect width="4" height="2" x="10" y="12" />
                    </Icon>
                );
            case 'searchMenu':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
                        <path d="M21 21l-6 -6"></path>
                    </Icon>
                );
            case 'favouritMenu':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572" />
                    </Icon>
                );
            case 'highlightMenu':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M17.286 21.09q -1.69 .001 -5.288 -2.615q -3.596 2.617 -5.288 2.616q -2.726 0 -.495 -6.8q -9.389 -6.775 2.135 -6.775h.076q 1.785 -5.516 3.574 -5.516q 1.785 0 3.574 5.516h.076q 11.525 0 2.133 6.774q 2.23 6.802 -.497 6.8" />
                    </Icon>
                );
            case 'layersMenu':
                return (
                    <Icon
                        viewBox="0 0 20 20"
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <g>
                            <path
                                d="M 9.9921875 2 A 0.50005 0.50005 0 0 0 9.7675781 2.0566406 L 0.26757812 7.0566406 A 0.50005 0.50005 0 0 0 0.26757812 7.9433594 L 9.7675781 12.943359 A 0.50005 0.50005 0 0 0 10.232422 12.943359 L 19.732422 7.9433594 A 0.50005 0.50005 0 0 0 19.732422 7.0566406 L 10.232422 2.0566406 A 0.50005 0.50005 0 0 0 9.9921875 2 z M 10 3.0664062 L 18.425781 7.5 L 10 11.935547 L 1.5742188 7.5 L 10 3.0664062 z M 0.4921875 9.9960938 A 0.50005 0.50005 0 0 0 0.26757812 10.943359 L 9.7675781 15.943359 A 0.50005 0.50005 0 0 0 10.232422 15.943359 L 19.732422 10.943359 A 0.50058684 0.50058684 0 1 0 19.267578 10.056641 L 10 14.935547 L 0.73242188 10.056641 A 0.50005 0.50005 0 0 0 0.4921875 9.9960938 z M 0.4921875 12.996094 A 0.50005 0.50005 0 0 0 0.26757812 13.943359 L 9.7675781 18.943359 A 0.50005 0.50005 0 0 0 10.232422 18.943359 L 19.732422 13.943359 A 0.50058684 0.50058684 0 1 0 19.267578 13.056641 L 10 17.935547 L 0.73242188 13.056641 A 0.50005 0.50005 0 0 0 0.4921875 12.996094 z "
                                style={{
                                    fill: 'currentColor',
                                    stroke: 'none',
                                    strokeWidth: '0px',
                                }}
                            />
                        </g>
                    </Icon>
                );
            case 'plansMenu':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
                        <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path>
                        <path d="M0 12h9"></path>
                        <path d="M15 12h9"></path>
                        <path d="M13.6 9.4l3.4 -7"></path>
                        <path d="M10.4 14.6l-3.4 7"></path>
                        <path d="M5 3l5 6"></path>
                        <path d="M13.6 14.6l3.4 7"></path>
                    </Icon>
                );
            case 'analysisAreas':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M6 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path>
                        <path d="M16 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                        <path d="M14.5 7.5m-4.5 0a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0 -9 0"></path>
                    </Icon>
                );
            case 'manoeuvreInformation':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M3 3m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
                        <path d="M15 15m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
                        <path d="M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3"></path>
                        <path d="M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3"></path>
                    </Icon>
                );
            case 'enviromentalData':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M20 7l-3 5h4l-3 5"></path>
                        <path d="M3 16h4a2 2 0 1 1 0 4"></path>
                        <path d="M3 12h8a2 2 0 1 0 0 -4"></path>
                        <path d="M3 8h3a2 2 0 1 0 0 -4"></path>
                    </Icon>
                );
            case 'transitDisplay':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"></path>
                        <path d="M4 18l-1 -5h18l-2 4"></path>
                        <path d="M5 13v-6h8l4 6"></path>
                    </Icon>
                );
            case 'metOceanData':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M5 8h8.5a2.5 2.5 0 1 0 -2.34 -3.24"></path>
                        <path d="M3 12h15.5a2.5 2.5 0 1 1 -2.34 3.24"></path>
                        <path d="M4 16h5.5a2.5 2.5 0 1 1 -2.34 3.24"></path>
                    </Icon>
                );
            case 'measureArea':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M5 4h14a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-7a1 1 0 0 0 -1 1v7a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1"></path>
                        <path d="M4 8l2 0"></path>
                        <path d="M4 12l3 0"></path>
                        <path d="M4 16l2 0"></path>
                        <path d="M8 4l0 2"></path>
                        <path d="M12 4l0 3"></path>
                        <path d="M16 4l0 2"></path>
                    </Icon>
                );
            case 'measureLength':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M19.875 12c.621 0 1.125 .512 1.125 1.143v5.714c0 .631 -.504 1.143 -1.125 1.143h-15.875a1 1 0 0 1 -1 -1v-5.857c0 -.631 .504 -1.143 1.125 -1.143h15.75z" />
                        <path d="M9 12v2" />
                        <path d="M6 12v3" />
                        <path d="M12 12v3" />
                        <path d="M18 12v3" />
                        <path d="M15 12v2" />
                        <path d="M3 3v4" />
                        <path d="M3 5h18" />
                        <path d="M21 3v4" />
                    </Icon>
                );
            case 'drawing':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M3 21h4l13 -13a1.5 1.5 0 0 0 -4 -4l-13 13v4" />
                        <path d="M14.5 5.5l4 4" />
                        <path d="M12 8l-5 -5l-4 4l5 5" />
                        <path d="M7 8l-1.5 1.5" />
                        <path d="M16 12l5 5l-4 4l-5 -5" />
                        <path d="M16 17l-1.5 1.5" />
                    </Icon>
                );
            case 'eraseAll':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M19 20h-8.5l-4.21 -4.3a1 1 0 0 1 0 -1.41l10 -10a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41l-9.2 9.3" />
                        <path d="M18 13.3l-6.3 -6.3" />
                    </Icon>
                );
            case 'saveDrawing':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2" />
                        <path d="M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                        <path d="M14 4l0 4l-6 0l0 -4" />
                    </Icon>
                );
            case 'copyChart':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M6 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                        <path d="M18 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                        <path d="M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                        <path d="M8.7 10.7l6.6 -3.4" />
                        <path d="M8.7 13.3l6.6 3.4" />
                    </Icon>
                );
            case 'changeTime':
            case 'timeOptions':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4"></path>
                        <path d="M18 14v4h4"></path>
                        <path d="M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"></path>
                        <path d="M15 3v4"></path>
                        <path d="M7 3v4"></path>
                        <path d="M3 11h16"></path>
                    </Icon>
                );
            case 'hourLater':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M20.984 12.535a9 9 0 1 0 -8.468 8.45" />
                        <path d="M16 19h6" />
                        <path d="M19 16v6" />
                        <path d="M12 7v5l3 3" />
                    </Icon>
                );
            case 'hourEarlier':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M20.984 12.535a9 9 0 1 0 -8.468 8.45" />
                        <path d="M16 19h6" />
                        <path d="M12 7v5l3 3" />
                    </Icon>
                );
            case 'exportGrid':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5" />
                        <path d="M3 10h18" />
                        <path d="M10 3v18" />
                        <path d="M16 19h6" />
                        <path d="M19 16l3 3l-3 3" />
                    </Icon>
                );
            case 'gridSettings':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M4 8h4v4h-4z" />
                        <path d="M6 4l0 4" />
                        <path d="M6 12l0 8" />
                        <path d="M10 14h4v4h-4z" />
                        <path d="M12 4l0 10" />
                        <path d="M12 18l0 2" />
                        <path d="M16 5h4v4h-4z" />
                        <path d="M18 4l0 1" />
                        <path d="M18 9l0 11" />
                    </Icon>
                );
            case 'tagsGrid':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <circle cx="8.5" cy="8.5" r="1" fill="currentColor" />
                        <path d="M4 7v3.859c0 .537 .213 1.052 .593 1.432l8.116 8.116a2.025 2.025 0 0 0 2.864 0l4.834 -4.834a2.025 2.025 0 0 0 0 -2.864l-8.117 -8.116a2.025 2.025 0 0 0 -1.431 -.593h-3.859a3 3 0 0 0 -3 3z" />
                    </Icon>
                );
            case 'exportAnalysis':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5" />
                        <path d="M3 10h18" />
                        <path d="M10 3v18" />
                        <path d="M16 19h6" />
                        <path d="M19 16l3 3l-3 3" />
                    </Icon>
                );
            case 'updateAnalysis':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" />
                        <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" />
                    </Icon>
                );
            case 'timeMenu':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                        strokeWidth="2"
                        viewBox="0 0 80 80"
                    >
                        <path d="M78,62c-3,0-4.36,2.38-5.61,4.49S70.18,70,68.5,70a2.73,2.73,0,0,1-1.84-.71s0,0,0,0L75,38.34a1,1,0,0,0-.52-1.15L62,30.94V15.14C62,9.87,50.15,8,40,8S18,9.87,18,15.14v15.8L5.55,37.19A1,1,0,0,0,5,38.34l8.3,30.92s0,0,0,0A2.69,2.69,0,0,1,11.5,70c-1.69,0-2.59-1.33-3.89-3.51S4.94,62,2,62a1,1,0,0,0,0,2c1.68,0,2.59,1.33,3.89,3.51S8.55,72,11.5,72s4.36-2.38,5.61-4.49S19.31,64,21,64s2.6,1.33,3.89,3.51S27.55,72,30.49,72s4.36-2.38,5.61-4.49S38.3,64,40,64s2.59,1.33,3.89,3.51S46.55,72,49.49,72s4.36-2.39,5.61-4.49S57.31,64,59,64s2.59,1.33,3.89,3.51S65.55,72,68.5,72s4.36-2.38,5.61-4.49S76.31,64,78,64a1,1,0,0,0,0-2Zm-39,.1c-2.29.47-3.52,2.54-4.62,4.39C33.08,68.67,32.17,70,30.49,70s-2.59-1.33-3.89-3.51S23.94,62,21,62s-4.36,2.38-5.6,4.49l-.51.83L7.18,38.61,39,22.62Zm1.42-42A.92.92,0,0,0,40,20h0a.92.92,0,0,0-.41.1h0L20,29.93V15.14C20,12.31,29,10,40,10a59.22,59.22,0,0,1,14.19,1.5c3.69,1,5.81,2.29,5.81,3.64V29.93L40.45,20.11ZM64.6,66.49C63.35,64.38,61.93,62,59,62s-4.36,2.38-5.61,4.49S51.17,70,49.49,70s-2.59-1.33-3.89-3.51c-1.1-1.85-2.32-3.91-4.6-4.39V22.62l31.82,16-7.7,28.73Z" />
                    </Icon>
                );
            case 'playbackMenu':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                        strokeWidth="2"
                        viewBox="0 0 80 80"
                    >
                        <path d="M78,62c-3,0-4.36,2.38-5.61,4.49S70.18,70,68.5,70a2.73,2.73,0,0,1-1.84-.71s0,0,0,0L75,38.34a1,1,0,0,0-.52-1.15L62,30.94V15.14C62,9.87,50.15,8,40,8S18,9.87,18,15.14v15.8L5.55,37.19A1,1,0,0,0,5,38.34l8.3,30.92s0,0,0,0A2.69,2.69,0,0,1,11.5,70c-1.69,0-2.59-1.33-3.89-3.51S4.94,62,2,62a1,1,0,0,0,0,2c1.68,0,2.59,1.33,3.89,3.51S8.55,72,11.5,72s4.36-2.38,5.61-4.49S19.31,64,21,64s2.6,1.33,3.89,3.51S27.55,72,30.49,72s4.36-2.38,5.61-4.49S38.3,64,40,64s2.59,1.33,3.89,3.51S46.55,72,49.49,72s4.36-2.39,5.61-4.49S57.31,64,59,64s2.59,1.33,3.89,3.51S65.55,72,68.5,72s4.36-2.38,5.61-4.49S76.31,64,78,64a1,1,0,0,0,0-2Zm-39,.1c-2.29.47-3.52,2.54-4.62,4.39C33.08,68.67,32.17,70,30.49,70s-2.59-1.33-3.89-3.51S23.94,62,21,62s-4.36,2.38-5.6,4.49l-.51.83L7.18,38.61,39,22.62Zm1.42-42A.92.92,0,0,0,40,20h0a.92.92,0,0,0-.41.1h0L20,29.93V15.14C20,12.31,29,10,40,10a59.22,59.22,0,0,1,14.19,1.5c3.69,1,5.81,2.29,5.81,3.64V29.93L40.45,20.11ZM64.6,66.49C63.35,64.38,61.93,62,59,62s-4.36,2.38-5.61,4.49S51.17,70,49.49,70s-2.59-1.33-3.89-3.51c-1.1-1.85-2.32-3.91-4.6-4.39V22.62l31.82,16-7.7,28.73Z" />
                    </Icon>
                );
            case 'transitVessels':
            case 'otherTransits':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                        strokeWidth="2"
                        viewBox="0 0 80 80"
                    >
                        <path d="M78,62c-3,0-4.36,2.38-5.61,4.49S70.18,70,68.5,70a2.73,2.73,0,0,1-1.84-.71s0,0,0,0L75,38.34a1,1,0,0,0-.52-1.15L62,30.94V15.14C62,9.87,50.15,8,40,8S18,9.87,18,15.14v15.8L5.55,37.19A1,1,0,0,0,5,38.34l8.3,30.92s0,0,0,0A2.69,2.69,0,0,1,11.5,70c-1.69,0-2.59-1.33-3.89-3.51S4.94,62,2,62a1,1,0,0,0,0,2c1.68,0,2.59,1.33,3.89,3.51S8.55,72,11.5,72s4.36-2.38,5.61-4.49S19.31,64,21,64s2.6,1.33,3.89,3.51S27.55,72,30.49,72s4.36-2.38,5.61-4.49S38.3,64,40,64s2.59,1.33,3.89,3.51S46.55,72,49.49,72s4.36-2.39,5.61-4.49S57.31,64,59,64s2.59,1.33,3.89,3.51S65.55,72,68.5,72s4.36-2.38,5.61-4.49S76.31,64,78,64a1,1,0,0,0,0-2Zm-39,.1c-2.29.47-3.52,2.54-4.62,4.39C33.08,68.67,32.17,70,30.49,70s-2.59-1.33-3.89-3.51S23.94,62,21,62s-4.36,2.38-5.6,4.49l-.51.83L7.18,38.61,39,22.62Zm1.42-42A.92.92,0,0,0,40,20h0a.92.92,0,0,0-.41.1h0L20,29.93V15.14C20,12.31,29,10,40,10a59.22,59.22,0,0,1,14.19,1.5c3.69,1,5.81,2.29,5.81,3.64V29.93L40.45,20.11ZM64.6,66.49C63.35,64.38,61.93,62,59,62s-4.36,2.38-5.61,4.49S51.17,70,49.49,70s-2.59-1.33-3.89-3.51c-1.1-1.85-2.32-3.91-4.6-4.39V22.62l31.82,16-7.7,28.73Z" />
                    </Icon>
                );
            case 'portVessels':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"></path>
                        <path d="M4 18l-1 -5h18l-2 4"></path>
                        <path d="M5 13v-6h8l4 6"></path>
                        <path d="M7 7v-4h-1"></path>
                    </Icon>
                );
            case 'otherVessels':
                return (
                    <Icon
                        className={twclsx(
                            'w-5',
                            'h-5',
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"></path>
                        <path d="M4 18l-1 -3h18l-1 3"></path>
                        <path d="M11 12h7l-7 -9v9"></path>
                        <path d="M8 7l-2 5"></path>
                    </Icon>
                );
            case 'modifyMode':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" />
                        <path d="M13.5 6.5l4 4" />
                    </Icon>
                );
            case 'eraseMode':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M3 3l18 18" />
                        <path d="M19 20h-10.5l-4.21 -4.3a1 1 0 0 1 0 -1.41l5 -4.993m2.009 -2.01l3 -3a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41c-1.417 1.431 -2.406 2.432 -2.97 3m-2.02 2.043l-4.211 4.256" />
                        <path d="M18 13.3l-6.3 -6.3" />
                    </Icon>
                );
            case 'drawPolygonMode':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M5.581 2.186l6.566 4.69l7.502 -2.812a1 1 0 0 1 1.326 .714l.019 .112l1 9a1 1 0 0 1 -.678 1.059l-9 3a1 1 0 0 1 -.553 .023l-4.434 -1.082a3 3 0 0 1 -1.287 .923c.095 .986 .374 1.9 .826 2.69a1 1 0 0 1 -1.736 .993c-.624 -1.09 -.99 -2.335 -1.098 -3.656a3 3 0 0 1 -2.034 -2.84l.005 -.176a3 3 0 0 1 .86 -1.932l-.818 -2.59a1 1 0 0 1 -.009 -.577l2 -7a1 1 0 0 1 1.543 -.539m-.009 2.451l-1.528 5.348l.642 2.031q .155 -.016 .314 -.016a3 3 0 0 1 3 2.995l3.957 .965l7.96 -2.654l-.769 -6.919l-6.797 2.55a1 1 0 0 1 -.827 -.058l-.105 -.065z"></path>
                    </Icon>
                );
            case 'drawLineStringMode':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                        <path d="M18 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                        <path d="M7.5 16.5l9 -9"></path>
                    </Icon>
                );
            case 'drawPointMode':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"></path>
                    </Icon>
                );
            case 'drawRectangleMode':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>
                    </Icon>
                );
            case 'translateMode':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M19 11v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"></path>
                        <path d="M13 13l9 3l-4 2l-2 4l-3 -9"></path>
                        <path d="M3 3l0 .01"></path>
                        <path d="M7 3l0 .01"></path>
                        <path d="M11 3l0 .01"></path>
                        <path d="M15 3l0 .01"></path>
                        <path d="M3 7l0 .01"></path>
                        <path d="M3 11l0 .01"></path>
                        <path d="M3 15l0 .01"></path>
                    </Icon>
                );
            case 'scaleMode':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M6.141 4.163l12 1.714a1 1 0 0 1 .859 .99v10.266a1 1 0 0 1 -.859 .99l-12 1.714a1 1 0 0 1 -1.141 -.99v-13.694a1 1 0 0 1 1.141 -.99z"></path>
                    </Icon>
                );
            case 'drawCircleFromCenterMode':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
                    </Icon>
                );
            case 'labelMode':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M17 15l4 4m0 -4l-4 4" />
                        <path d="M7 6v-1h11v1" />
                        <path d="M7 19l4 0" />
                        <path d="M13 5l-4 14" />
                    </Icon>
                );
            case 'coordinateMode':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                        <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z" />
                    </Icon>
                );
            case 'tagsAndComments':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                        <path d="M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z"></path>
                    </Icon>
                );
            case 'dateRange':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4" />
                        <path d="M18 14v4h4" />
                        <path d="M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                        <path d="M15 3v4" />
                        <path d="M7 3v4" />
                        <path d="M3 11h16" />
                    </Icon>
                );
            case 'transit':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M3 14l11 -11" />
                        <path d="M10 3h4v4" />
                        <path d="M10 17v4h4" />
                        <path d="M21 10l-11 11" />
                    </Icon>
                );
            case 'transitRoute':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M4 16l6 -7l5 5l5 -6"></path>
                        <path d="M15 14m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                        <path d="M10 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                        <path d="M4 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                        <path d="M20 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                    </Icon>
                );
            case 'vessel':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                        strokeWidth="2"
                        viewBox="0 0 80 80"
                    >
                        <path d="M78,62c-3,0-4.36,2.38-5.61,4.49S70.18,70,68.5,70a2.73,2.73,0,0,1-1.84-.71s0,0,0,0L75,38.34a1,1,0,0,0-.52-1.15L62,30.94V15.14C62,9.87,50.15,8,40,8S18,9.87,18,15.14v15.8L5.55,37.19A1,1,0,0,0,5,38.34l8.3,30.92s0,0,0,0A2.69,2.69,0,0,1,11.5,70c-1.69,0-2.59-1.33-3.89-3.51S4.94,62,2,62a1,1,0,0,0,0,2c1.68,0,2.59,1.33,3.89,3.51S8.55,72,11.5,72s4.36-2.38,5.61-4.49S19.31,64,21,64s2.6,1.33,3.89,3.51S27.55,72,30.49,72s4.36-2.38,5.61-4.49S38.3,64,40,64s2.59,1.33,3.89,3.51S46.55,72,49.49,72s4.36-2.39,5.61-4.49S57.31,64,59,64s2.59,1.33,3.89,3.51S65.55,72,68.5,72s4.36-2.38,5.61-4.49S76.31,64,78,64a1,1,0,0,0,0-2Zm-39,.1c-2.29.47-3.52,2.54-4.62,4.39C33.08,68.67,32.17,70,30.49,70s-2.59-1.33-3.89-3.51S23.94,62,21,62s-4.36,2.38-5.6,4.49l-.51.83L7.18,38.61,39,22.62Zm1.42-42A.92.92,0,0,0,40,20h0a.92.92,0,0,0-.41.1h0L20,29.93V15.14C20,12.31,29,10,40,10a59.22,59.22,0,0,1,14.19,1.5c3.69,1,5.81,2.29,5.81,3.64V29.93L40.45,20.11ZM64.6,66.49C63.35,64.38,61.93,62,59,62s-4.36,2.38-5.61,4.49S51.17,70,49.49,70s-2.59-1.33-3.89-3.51c-1.1-1.85-2.32-3.91-4.6-4.39V22.62l31.82,16-7.7,28.73Z" />
                    </Icon>
                );
            case 'metOcean':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M5 8h8.5a2.5 2.5 0 1 0 -2.34 -3.24" />
                        <path d="M3 12h15.5a2.5 2.5 0 1 1 -2.34 3.24" />
                        <path d="M4 16h5.5a2.5 2.5 0 1 1 -2.34 3.24" />
                    </Icon>
                );
            case 'admin':
                return (
                    <Icon
                        className={twclsx(
                            !menu.active || !hasPermission(this.props.user, this.props.port.id, menu.permissions)
                                ? 'text-gray-500'
                                : menu.state
                                ? 'text-selectedIcon'
                                : 'text-activeIcon'
                        )}
                    >
                        <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
                        <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                    </Icon>
                );
            default:
        }
    };

    activeTool = (toolKey: string, sectionKey: string): boolean => {
        switch (toolKey) {
            case 'saveFavourit':
                this.props.openModelFunction(
                    'saveSearchModel',
                    0,
                    'medium',
                    {
                        searchObject: this.props.searchObject,
                    },
                    {
                        onCancel: () => {
                            this.props.openModelFunction('saveSearchModel');
                        },
                    }
                );
                return false;
            case 'playbackTransit':
                this.playbackTransit();
                return false;
            case 'downloadTransit':
                this.downloadTransit();
                return false;
            case 'highlightTransit':
                this.highlightTransit();
                return false;
            case 'updateDrawTrack':
                this.updateDrawTrack();
                return false;
            case 'updateDrawVesselOutline':
                this.updateDrawVesselOutline();
                return false;
            case 'editTransit':
                this.editTransit();
                return false;
            case 'transitTagsAndComments':
                this.transitTagsAndComments();
                return false;
            case 'transitDownloadSweptPathFile':
                this.transitDownloadSweptPathFile();
                return false;
            case 'showAllTransits':
                this.props.mainControls.updateDisplayAll([0], false);
                return false;
            case 'inspectTransit':
                console.log('inspect Transit');
                break;
            case 'pointer':
                this.props.menuControls.drawing?.setDrawingMode('pointer', sectionKey);
                this.props.setLayoutAction([
                    {
                        action: 'UPDATE_TOOLS_SECTION',
                        data: {
                            tool: 'drawing',
                            section: getMode(this.props.mode),
                            name: 'pointer',
                            state: true,
                        },
                    },
                ]);
                break;
            case 'labelMode':
                if (!this.state.layout.sections[sectionKey].tools.drawing.sections[toolKey].state) {
                    this.props.showMessageAction({
                        messageType: 'CLOSE',
                    });
                    this.props.showMessageAction({
                        messageType: 'INFO',
                        message: translate('Select object to label'),
                        options: {
                            autoClose: false,
                            hideProgressBar: true,
                        },
                    });
                } else {
                    this.props.showMessageAction({
                        messageType: 'CLOSE',
                    });
                }
                this.props.menuControls.drawing?.setDrawingMode('labelMode', sectionKey);
                this.props.setLayoutAction([
                    {
                        action: 'UPDATE_TOOLS_SECTION',
                        data: {
                            tool: 'drawing',
                            section: getMode(this.props.mode),
                            name: 'labelMode',
                            state: true,
                        },
                    },
                ]);
                break;
            case 'coordinateMode':
                this.props.menuControls.drawing?.setDrawingMode('coordinateMode', sectionKey);
                this.props.setLayoutAction([
                    {
                        action: 'UPDATE_TOOLS_SECTION',
                        data: {
                            tool: 'drawing',
                            section: getMode(this.props.mode),
                            name: 'coordinateMode',
                            state: true,
                        },
                    },
                ]);
                break;
            case 'saveDrawing':
                this.props.setLayoutAction([
                    {
                        action: 'UPDATE_TOOLS_SECTION',
                        data: {
                            tool: 'drawing',
                            section: getMode(this.props.mode),
                            name: 'saveDrawing',
                            state: false,
                        },
                    },
                ]);
                {
                    let featureCollection: any;
                    switch (this.props.mode) {
                        case 'search':
                            featureCollection = this.props.mapControls.chart?.getDrawingFeatures();

                            break;
                        case 'playback':
                            featureCollection = this.props.mapControls.playback?.getDrawingFeatures();
                            break;
                        case 'live':
                        case 'time':
                            featureCollection = this.props.mapControls.time?.getDrawingFeatures();
                            break;
                        default:
                            break;
                    }

                    if (featureCollection) {
                        featureCollection.features = featureCollection.features.filter((x) => {
                            return !x.properties.type.includes('measure');
                        });
                        if (featureCollection.features.length >= 1) {
                            const blob = new Blob([JSON.stringify(featureCollection, null, 2)], {
                                type: 'text/plain;charset=utf-8',
                            });
                            const url = URL.createObjectURL(blob);

                            // Create a link to download it
                            const pom = document.createElement('a');
                            pom.href = url;
                            pom.setAttribute('download', `drawing.json`);
                            pom.click();
                        }
                    }
                }

                break;

            case 'measureLength':
            case 'measureArea':
                {
                    const drawingMode = DRAWING_MODES[`${toolKey}Mode`];

                    if (
                        !this.state.layout.sections[sectionKey].tools[toolKey].state &&
                        drawingMode.message &&
                        drawingMode.message !== ''
                    ) {
                        this.props.showMessageAction({
                            messageType: 'CLOSE',
                        });

                        this.props.showMessageAction({
                            messageType: 'INFO',

                            message: translate('Double click or press ENTER to end measuring'),
                            options: {
                                autoClose: false,
                                hideProgressBar: true,
                            },
                        });
                    } else {
                        this.props.showMessageAction({
                            messageType: 'CLOSE',
                        });
                    }

                    this.props.setLayoutAction([
                        {
                            action: 'UPDATE_TOOLS_SECTION',
                            data: {
                                tool: 'drawing',
                                section: getMode(this.props.mode),
                                name: 'pointer',
                                state: true,
                            },
                        },
                    ]);
                    this.props.menuControls.drawing?.setDrawingMode(
                        !this.state.layout.sections[sectionKey].tools[toolKey].state ? `${toolKey}Mode` : 'pointer',
                        sectionKey
                    );
                }
                break;

            case 'eraseMode':
            case 'modifyMode':
            case 'drawPolygonMode':
            case 'drawLineStringMode':
            case 'drawPointMode':
            case 'drawRectangleMode':
            case 'drawCircleFromCenterMode':
                {
                    const drawingMode = DRAWING_MODES[toolKey];

                    if (
                        !this.state.layout.sections[sectionKey].tools.drawing.sections[toolKey].state &&
                        drawingMode.message &&
                        drawingMode.message !== ''
                    ) {
                        this.props.showMessageAction({
                            messageType: 'CLOSE',
                        });
                        this.props.showMessageAction({
                            messageType: 'INFO',
                            message: translate(drawingMode.message),
                            options: {
                                autoClose: false,
                                hideProgressBar: true,
                            },
                        });
                    } else {
                        this.props.showMessageAction({
                            messageType: 'CLOSE',
                        });
                    }

                    this.props.menuControls.drawing?.setDrawingMode(
                        !this.state.layout.sections[sectionKey].tools.drawing.sections[toolKey].state
                            ? toolKey
                            : 'pointer',
                        sectionKey
                    );

                    if (this.state.layout.sections[sectionKey].tools.drawing.sections[toolKey].state) {
                        this.props.setLayoutAction([
                            {
                                action: 'UPDATE_MENU',
                                data: {
                                    name: 'drawing',
                                    section: 'chart',
                                    state: false,
                                },
                            },
                        ]);
                    }
                }
                break;
            case 'drawing':
                if (this.state.layout.sections[getMode(this.props.mode)].tools.drawing.state) {
                    this.props.setLayoutAction([
                        {
                            action: 'UPDATE_TOOLS',
                            data: {
                                section: getMode(this.props.mode),
                                names: ['drawing'],
                                state: false,
                            },
                        },
                        {
                            action: 'UPDATE_TOOLS_SECTION',
                            data: {
                                tool: 'drawing',
                                section: getMode(this.props.mode),
                                name: 'pointer',
                                state: true,
                            },
                        },
                    ]);

                    this.props.menuControls.drawing?.setDrawingMode('pointer', sectionKey);
                }
                break;
            case 'eraseAll':
                this.props.openModelFunction(
                    'eraseAllModel',
                    0,
                    'medium',
                    {},
                    {
                        onCancel: () => {
                            this.props.setLayoutAction([
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'eraseAll',
                                        section: getMode(this.props.mode),
                                        state: false,
                                    },
                                },
                                {
                                    action: 'UPDATE_TOOLS_SECTION',
                                    data: {
                                        tool: 'drawing',
                                        section: getMode(this.props.mode),
                                        name: 'pointer',
                                        state: true,
                                    },
                                },
                            ]);
                            this.props.menuControls.drawing?.setDrawingMode('pointer', sectionKey);
                            this.props.openModelFunction('eraseAllModel');
                        },
                        onConfirm: () => {
                            this.clearMap(sectionKey);
                        },
                    },
                    true
                );

                break;
            case 'gridSettings':
                this.props.setLayoutAction([
                    {
                        action: 'UPDATE_TOOLS',
                        data: {
                            section: 'grid',
                            names: [toolKey],
                            state: false,
                        },
                    },
                ]);
                this.props.openModelFunction(
                    'gridSettingModel',
                    0,
                    'medium',
                    {},
                    {
                        onCancel: () => {
                            this.props.openModelFunction('gridSettingModel');
                        },
                        onConfirm: () => {
                            //console.log('saved');
                        },
                    },
                    true
                );
                break;
            case 'exportGrid':
                this.props.setLayoutAction([
                    {
                        action: 'UPDATE_TOOLS',
                        data: {
                            section: 'grid',
                            names: [toolKey],
                            state: false,
                        },
                    },
                ]);
                this.props.mainControls.transitsExportFile();
                break;
            case 'tagsGrid':
                {
                    this.props.setLayoutAction([
                        {
                            action: 'UPDATE_TOOLS',
                            data: {
                                section: 'grid',
                                names: [toolKey],
                                state: false,
                            },
                        },
                    ]);
                    const { transits } = this.props.mainControls.getTransit(0);
                    if (
                        !transits.filter((x) => {
                            return x.options.select;
                        }).length
                    ) {
                        this.props.showMessageAction({
                            messageType: 'WARN',
                            message: translate('No transits selected.'),
                        });

                        return false;
                    }

                    this.props.openModelFunction(
                        'allTransitTagsAndCommentsModel',
                        0,
                        'medium',
                        {},
                        {
                            onCancel: () => {
                                this.props.openModelFunction('allTransitTagsAndCommentsModel');
                            },
                            onConfirm: () => {
                                //console.log('saved');
                            },
                        },
                        true
                    );
                }
                break;
            case 'exportAnalysis':
                this.props.profileControls.exportProfile();
                this.props.setLayoutAction([
                    {
                        action: 'UPDATE_TOOLS',
                        data: {
                            section: 'profile',
                            names: [toolKey],
                            state: false,
                        },
                    },
                ]);
                break;
            case 'copyChart':
                {
                    const { transits } = this.props.mainControls.getTransit(0);
                    const saveScreenData = {
                        searchObject: this.props.searchObject,
                        highlightObject: this.props.highlightObject,
                        clickMatrix: this.props.mapControls.chart?.getClickMatrix(0),
                        tooltips: this.props.mapControls.chart?.getTooltips(),
                        outlineInterval: this.props.outlineInterval,
                        switchs: this.props.switchs,
                        portId: this.props.port.id,
                        inspectTransit: this.props.layout.inspectTransit,
                        inspectSelectedTime: this.props.layout.inspectSelectedTime,
                        systemName: this.props.port.name,
                        map: this.props.mapControls.chart?.getViewPort(),
                        pilotagePlanSettings: this.props.pilotagePlanSettings,
                        pilotagePlans: this.props.pilotagePlans,
                        transits: transits.map((x) => {
                            return { id: x.id, ...x.options };
                        }),
                    };

                    savedScreensCreate({ data: saveScreenData, name: 'Save chart', port_id: this.props.port.id })
                        .then((res) => {
                            copyToClipboard(
                                `${window.location.protocol}//${window.location.host}/chart/${res.items.uuid}`
                            );
                            this.props.showMessageAction({
                                messageType: 'INFO',
                                message: translate(
                                    'The link to this chart, search, and transit(s) has been copied to your clipboard.'
                                ),
                            });
                        })
                        .catch((error) => {
                            this.props.setErrorHandlerAction(error);
                            return []; // Return an empty array or handle it based on your use case
                        });
                }
                break;
            case 'updateAnalysis':
                this.props.profileControls.updateProfile();
                this.props.setLayoutAction([
                    {
                        action: 'UPDATE_TOOLS',
                        data: {
                            section: 'profile',
                            names: [toolKey],
                            state: false,
                        },
                    },
                ]);
                break;
            case 'hourLater':
                {
                    const time = this.props.menuControls.time?.getDate();
                    this.props.mapControls.time?.hideTooltips();
                    const newTime = time?.clone().plus({ hours: TIME_MODE_RANG_HOURS });

                    if (newTime?.isAfter(this.props.system.date.today.date)) {
                        this.props.showMessageAction({
                            messageType: 'WARN',
                            message: translate('No AIS data avalable for the next hour .'),
                        });

                        return false;
                    }

                    this.changeTime({
                        startTime: time?.clone().plus({ hours: TIME_MODE_RANG_HOURS }),
                        endTime: time?.plus({ hours: TIME_MODE_RANG_HOURS + TIME_MODE_RANG_HOURS }),
                    });
                }
                break;
            case 'hourEarlier':
                {
                    const time = this.props.menuControls.time?.getDate();
                    this.props.mapControls.time?.hideTooltips();

                    this.changeTime({
                        startTime: time?.clone().minus({ hours: TIME_MODE_RANG_HOURS }),
                        endTime: time?.clone(),
                    });
                }
                break;
            case 'changeTime':
                this.props.openModelFunction(
                    'changeTimeModel',
                    0,
                    'custom',
                    {},
                    {
                        onCancel: () => {
                            this.props.openModelFunction('changeTimeModel');
                        },
                        onConfirm: this.changeTime,
                    },
                    true
                );
                this.props.setLayoutAction([
                    {
                        action: 'UPDATE_TOOLS',
                        data: {
                            section: 'profile',
                            names: [toolKey],
                            state: false,
                        },
                    },
                    {
                        action: 'UPDATE_TOOLS',
                        data: {
                            section: 'chart',
                            names: [toolKey],
                            state: false,
                        },
                    },
                    {
                        action: 'UPDATE_TOOLS',
                        data: {
                            section: 'grid',
                            names: [toolKey],
                            state: false,
                        },
                    },
                ]);
                break;
            default:
                break;
        }
        return true;
    };

    changeTime = (time) => {
        this.props.menuControls.time?.changeDateRange(time.startTime, time.endTime.clone(), time.endTime.clone());

        this.props.setLayoutAction([
            {
                action: 'UPDATE_MODE',
                data: {
                    section: 'time',
                    mode: time.endTime.isBetween(
                        this.props.system.date.today.clone().minus({ hours: TIME_MODE_RANG_HOURS }).date,
                        this.props.system.date.today.date
                    )
                        ? 'live'
                        : 'time',
                },
            },
            {
                action: 'UPDATE_MODE',
                data: {
                    section: 'replay',
                    mode: time.endTime.isBetween(
                        this.props.system.date.today.clone().minus({ hours: TIME_MODE_RANG_HOURS }).date,
                        this.props.system.date.today.date
                    )
                        ? 'live'
                        : 'time',
                },
            },
            {
                action: 'UPDATE_MODE',
                data: {
                    section: 'replay',
                    mode: time.endTime.isBetween(
                        this.props.system.date.today.clone().minus({ hours: TIME_MODE_RANG_HOURS }).date,
                        this.props.system.date.today.date
                    )
                        ? 'live'
                        : 'time',
                },
            },
            {
                action: 'UPDATE_DATA',
                data: {
                    section: 'time',
                    data: {
                        startTime: time.startTime,
                        endTime: time.endTime,
                    },
                },
            },
            {
                action: 'UPDATE_SECTION',
                data: { name: 'replay', loading: true, state: true, display: true, disable: false },
            },
            {
                action: 'UPDATE_SECTION',
                data: { name: 'time', loading: true, state: true, display: true, disable: false },
            },
            {
                action: 'UPDATE_MENU',
                data: {
                    name: 'timeMenu',
                    section: 'time',
                    state: true,
                },
            },
        ]);
    };

    clearMap = (sectionKey: string) => {
        switch (this.props.mode) {
            case 'search':
                this.props.mapControls.chart?.clearMap(true);
                this.props.mapControls.chart?.clearTooltips();
                this.props.menuControls.drawing?.setDrawingMode('pointer', sectionKey);

                break;
            case 'playback':
                this.props.mapControls.playback?.clearMap(true);
                this.props.mapControls.playback?.clearTooltips();
                this.props.menuControls.drawing?.setDrawingMode('pointer', sectionKey);
                break;
            case 'live':
            case 'time':
                this.props.mapControls.time?.clearMap(true);
                this.props.mapControls.time?.clearTooltips();
                this.props.menuControls.drawing?.setDrawingMode('pointer', sectionKey);
                break;

            default:
                break;
        }
        this.props.showMessageAction({
            messageType: 'CLOSE',
        });

        this.props.setLayoutAction([
            {
                action: 'UPDATE_TOOLS',
                data: {
                    section: sectionKey,
                    names: ['eraseAll'],
                    state: false,
                },
            },
        ]);
    };

    renderItem = (section: string, group: string) => {
        const items: any = [];

        if (this.state.layout.sections[section].menus) {
            Object.keys(this.state.layout.sections[section].menus)
                .filter((menukey) => {
                    return this.state.layout.sections[section].menus[menukey].display;
                })
                .forEach((menukey) => {
                    if (this.state.layout.sections[section].menus[menukey].group === group) {
                        items.push({
                            groupIndex: this.state.layout.sections[section].menus[menukey].groupIndex,
                            section,

                            key: menukey,
                            type: 'menu',
                        });
                    }
                });
        }
        if (this.state.layout.sections[section].tools) {
            Object.keys(this.state.layout.sections[section].tools)
                .filter((toolkey) => {
                    return this.state.layout.sections[section].tools[toolkey].display;
                })
                .forEach((toolkey) => {
                    if (this.state.layout.sections[section].tools[toolkey].group === group) {
                        items.push({
                            groupIndex: this.state.layout.sections[section].tools[toolkey].groupIndex,
                            section,
                            key: toolkey,
                            type: 'tool',
                        });
                    }
                });
        }

        return items;
    };

    updateSubItems = (index, data) => {
        const itemHeight = 32;
        const groupSpacing = 16;

        const countBefore = data.slice(0, index).reduce((count, inner) => count + inner.length, 0);

        const baseSpace = countBefore * itemHeight + index * groupSpacing;

        // Add incremental `space` to each item in the target group
        data[index] = data[index].map((item, i) => ({
            ...item,
            space: baseSpace + i * itemHeight,
        }));

        return data[index];
    };

    renderMenuItem = (section, menukey, space) => {
        return (
            <>
                <div
                    key={`${section}Menu-${menukey}`}
                    data-tooltip-id={`${section}-menu-${menukey}-tooltip`}
                    className={twclsx(
                        'w-10',
                        'h-10',
                        'justify-center',
                        'items-center',
                        'rounded-md',
                        this.state.layout.sections[section].menus[menukey].state && 'bg-primary-systemSecondary'
                    )}
                >
                    <div
                        onClick={() => {
                            if (
                                !this.state.layout.sections[section].menus[menukey].active ||
                                !hasPermission(
                                    this.props.user,
                                    this.props.port.id,
                                    this.state.layout.sections[section].menus[menukey].permissions
                                )
                            ) {
                                return;
                            }
                            this.props.mapControls[section]?.hideTooltips();
                            this.props.setLayoutAction([
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: menukey,
                                        section: section,
                                        state: !this.state.layout.sections[section].menus[menukey].state,
                                    },
                                },
                            ]);
                            this.activeTool('pointer', section);
                            this.props.showMessageAction({
                                messageType: 'CLOSE',
                            });
                        }}
                        className={twclsx(
                            'w-full',
                            'h-full',
                            'flex',
                            'cursor-pointer',
                            'justify-center',
                            'relative',
                            'items-center',
                            Object.keys(this.state.layout.sections[section].menus[menukey].sections).length === 0
                                ? ''
                                : this.state.layout.sections[section].menus[menukey].state
                                ? 'with-sub-menu-active'
                                : 'with-sub-menu',
                            'overflow-hidden'
                        )}
                    >
                        {this.renderIcon(menukey, this.state.layout.sections[section].menus[menukey])}
                    </div>
                    {this.state.layout.sections[section].menus[menukey].label &&
                        !this.state.layout.sections[section].menus[menukey].state && (
                            <Tooltip
                                className="z-40"
                                id={`${section}-menu-${menukey}-tooltip`}
                                html={translate(this.state.layout.sections[section].menus[menukey].label)}
                                place={'right'}
                            />
                        )}
                </div>
                {this.state.layout.sections[section].menus[menukey].state &&
                    Object.keys(this.state.layout.sections[section].menus[menukey].sections).length > 0 && (
                        <div
                            style={{
                                paddingTop: space + 8,
                            }}
                            className="z-20 border-r bg-primary-system border-l border-primary-toolbarGroup  py-4 items-center flex-col  fixed flex  ml-subMenu top-0 w-12 mt-14 h-screen"
                        >
                            {Object.keys(this.state.layout.sections[section].menus[menukey].sections)
                                .filter((sectionKey) => {
                                    return this.state.layout.sections[section].menus[menukey].sections[sectionKey]
                                        .display;
                                })
                                .map((sectionKey) => {
                                    return (
                                        <div
                                            key={`${section}MenuSection-${sectionKey}`}
                                            onClick={() => {
                                                if (
                                                    !hasPermission(
                                                        this.props.user,
                                                        this.props.port.id,
                                                        this.state.layout.sections[section].menus[menukey].sections[
                                                            sectionKey
                                                        ].permissions
                                                    ) ||
                                                    !this.state.layout.sections[section].menus[menukey].sections[
                                                        sectionKey
                                                    ].active
                                                ) {
                                                    return;
                                                }

                                                const execute = this.activeTool(sectionKey, section);

                                                if (execute) {
                                                    this.props.setLayoutAction([
                                                        {
                                                            action: 'UPDATE_MENU_SECTION',
                                                            data: {
                                                                menu: menukey,
                                                                section: section,
                                                                name: sectionKey,
                                                                state: true,
                                                            },
                                                        },
                                                    ]);
                                                }
                                            }}
                                            className={twclsx(
                                                this.state.layout.sections[section].menus[menukey].state &&
                                                    this.state.layout.sections[section].menus[menukey].sections[
                                                        sectionKey
                                                    ].state &&
                                                    'bg-primary-systemSecondary',

                                                'flex',
                                                'cursor-pointer',
                                                'items-center',
                                                'rounded-md',
                                                'justify-center',
                                                'w-10',
                                                'h-10'
                                            )}
                                            data-tooltip-id={`${section}-${menukey}-section${sectionKey}-tooltip`}
                                        >
                                            {this.renderIcon(
                                                sectionKey,
                                                this.state.layout.sections[section].menus[menukey].sections[sectionKey]
                                            )}

                                            <Tooltip
                                                className="z-40"
                                                id={`${section}-${menukey}-section${sectionKey}-tooltip`}
                                                html={translate(
                                                    this.state.layout.sections[section].menus[menukey].sections[
                                                        sectionKey
                                                    ].label
                                                )}
                                                place={'right'}
                                            />
                                        </div>
                                    );
                                })}
                        </div>
                    )}
            </>
        );
    };
    renderToolItem = (section, toolkey, space) => {
        return (
            <>
                <div
                    key={`${section}tool-${toolkey}`}
                    className={twclsx(
                        'w-10',
                        'h-10',
                        'flex',
                        'cursor-pointer',
                        'justify-center',
                        'rounded-md',
                        this.state.layout.sections[section].tools[toolkey].state && 'bg-primary-systemSecondary'
                    )}
                >
                    <div
                        data-tooltip-id={`${section}-tool-${toolkey}-tooltip`}
                        onClick={() => {
                            if (
                                !this.state.layout.sections[section].tools[toolkey].active ||
                                !hasPermission(
                                    this.props.user,
                                    this.props.port.id,
                                    this.state.layout.sections[section].tools[toolkey].permissions
                                )
                            ) {
                                return;
                            }

                            this.props.setLayoutAction([
                                {
                                    action: 'UPDATE_TOOLS',
                                    data: {
                                        section: section,
                                        names: [toolkey],
                                        state: !this.state.layout.sections[section].tools[toolkey].state,
                                    },
                                },
                            ]);
                            this.activeTool('pointer', section);
                            this.activeTool(toolkey, section);
                        }}
                        className={twclsx(
                            'w-full',
                            'h-full',
                            'flex',
                            'cursor-pointer',
                            'justify-center',
                            'relative',
                            'items-center',
                            Object.keys(this.state.layout.sections[section].tools[toolkey]?.sections || []).length === 0
                                ? ''
                                : this.state.layout.sections[section].tools[toolkey].state
                                ? 'with-sub-menu-active'
                                : 'with-sub-menu',
                            'overflow-hidden'
                        )}
                    >
                        {this.renderIcon(toolkey, this.state.layout.sections[section].tools[toolkey])}
                    </div>
                    {this.state.layout.sections[section].tools[toolkey].label &&
                        !this.state.layout.sections[section].tools[toolkey].state && (
                            <Tooltip
                                className="z-40"
                                id={`${section}-tool-${toolkey}-tooltip`}
                                html={translate(this.state.layout.sections[section].tools[toolkey].label)}
                                place={'right'}
                            />
                        )}
                </div>

                {this.state.layout.sections[section].tools[toolkey].state &&
                    Object.keys(this.state.layout.sections[section].tools[toolkey].sections).length > 0 && (
                        <div
                            style={{
                                paddingTop: space + 8,
                            }}
                            className="z-20 border-r bg-primary-system border-l border-primary-toolbarGroup  py-4 items-center flex-col  fixed flex  ml-subMenu top-0 w-12 mt-14 h-screen"
                        >
                            {Object.keys(this.state.layout.sections[section].tools[toolkey].sections)
                                .filter((sectionKey) => {
                                    return this.state.layout.sections[section].tools[toolkey].sections[sectionKey]
                                        .display;
                                })
                                .map((sectionKey) => {
                                    return (
                                        <div
                                            key={`${section}ToolsSection-${sectionKey}`}
                                            onClick={() => {
                                                this.props.showMessageAction({
                                                    messageType: 'CLOSE',
                                                });
                                                if (
                                                    !hasPermission(
                                                        this.props.user,
                                                        this.props.port.id,
                                                        this.state.layout.sections[section].tools[toolkey].sections[
                                                            sectionKey
                                                        ].permissions
                                                    )
                                                ) {
                                                    return;
                                                }

                                                this.props.setLayoutAction([
                                                    {
                                                        action: 'UPDATE_TOOLS_SECTION',
                                                        data: {
                                                            tool: toolkey,
                                                            section: section,
                                                            name: sectionKey,
                                                            state: !this.state.layout.sections[section].tools[toolkey]
                                                                .sections[sectionKey].state,
                                                        },
                                                    },
                                                ]);
                                                this.activeTool(sectionKey, section);
                                            }}
                                            className={twclsx(
                                                this.state.layout.sections[section].tools[toolkey].state &&
                                                    this.state.layout.sections[section].tools[toolkey].sections[
                                                        sectionKey
                                                    ].state &&
                                                    'text-selectedIcon',

                                                'flex',
                                                'cursor-pointer',
                                                'items-center',
                                                'justify-center',
                                                'w-8',
                                                'h-8'
                                            )}
                                            data-tooltip-id={`${section}-${toolkey}-section${sectionKey}-tooltip`}
                                        >
                                            {this.renderIcon(
                                                sectionKey,
                                                this.state.layout.sections[section].tools[toolkey].sections[sectionKey]
                                            )}

                                            <Tooltip
                                                className="z-40"
                                                id={`${section}-${toolkey}-section${sectionKey}-tooltip`}
                                                html={translate(
                                                    this.state.layout.sections[section].tools[toolkey].sections[
                                                        sectionKey
                                                    ].label
                                                )}
                                                place={'right'}
                                            />
                                        </div>
                                    );
                                })}
                        </div>
                    )}
            </>
        );
    };

    render() {
        return (
            <div className="z-30  gap-2 py-2  fixed flex flex-col  left-0 top-0 w-14  bg-primary-system h-screen  ">
                <div
                    id="omc-hub-anchor"
                    className="w-14 px-2 flex mb-2 justify-center items-center select-none cursor-pointer"
                >
                    {!this.props.interfaceVariables?.omc_hub_enabled && (
                        <span className="l">
                            <span className="lg">
                                <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                    <g transform="translate(1.08 6)">
                                        <path
                                            fill="currentColor"
                                            d="M29.97 13.43C29.91 13.03 29.8 12.64 29.64 12.27C29.18 11.18 28.37 10.22 27.22 9.4L27.22 7.63L29.82 0.85C29.9 0.65 29.87 0.44 29.75 0.27C29.62 0.1 29.44 0 29.23 0L14.09 0C13.83 0 13.61 0.15 13.51 0.38C13.37 0.71 13.1 1.11 12.71 1.5L8 1.5L8 3.14L6.89 3.14L6.89 1.48L1.7 1.48L1.7 4.34L1.7 4.39L9.6 4.39C9.62 4.39 9.65 4.39 9.69 4.39C11.8 4.11 13.7 2.63 14.49 1.24L28.32 1.24L26.01 7.27C25.98 7.35 25.97 7.42 25.97 7.5L25.97 9.72C25.97 9.93 26.08 10.13 26.25 10.25C27.03 10.76 27.64 11.35 28.06 11.98C27.86 12.98 27.04 14.13 24.69 14.87C21.42 15.9 14.39 13.4 8.87 13.53C4.05 13.64 0 16.86 0 16.86C1.72 16.33 6.38 16.32 8.87 16.81C12.3 17.48 19.63 20.07 24.78 19.42C25.54 19.37 26.26 19.19 26.92 18.89C29.34 17.91 30.39 15.64 29.97 13.43Z"
                                        ></path>
                                        <path
                                            fill="#009483"
                                            d="M7.25 12.48C8.2 12.18 10.35 11.78 12.5 12.15C14.54 12.49 20.52 14.25 23.34 13.39C24.65 13 26.26 11.03 24.38 8.44C24.38 8.44 24.39 9.64 23.56 10.15C22.65 10.72 22.01 10.78 21.16 10.82C19.08 10.92 15 9.92 11.96 9.99C9.3 10.06 7.25 12.48 7.25 12.48Z"
                                        ></path>
                                    </g>
                                </svg>
                            </span>
                        </span>
                    )}
                </div>

                {Object.keys(this.state.layout.sections)
                    .filter((section) => {
                        return this.state.layout.sections[section].state;
                    })
                    .map((section) => {
                        return (
                            <>
                                {Object.keys(this.state.layout.sections[section].toolbarGroups)
                                    .map((groupName) => {
                                        return this.renderItem(section, groupName);
                                    })
                                    .filter((groupData) => {
                                        return groupData.length > 0;
                                    })
                                    .map((groupData, index, data) => {
                                        return this.updateSubItems(index, data);
                                    })
                                    .map((groupData) => {
                                        return groupData
                                            .sort((a, b) => a.groupIndex - b.groupIndex)
                                            .map((x) => {
                                                if (x.type === 'menu') {
                                                    return this.renderMenuItem(x.section, x.key, x.space);
                                                }

                                                return this.renderToolItem(x.section, x.key, x.space);
                                            });
                                    })
                                    .map((groupData, index) => {
                                        return (
                                            <div key={index} className="w-14 px-2 flex justify-center items-center ">
                                                <div className=" rounded-md select-none w-full flex justify-center items-center flex-col ">
                                                    {groupData}
                                                    <div className="h-separator mt-1 w-full bg-primary-border"></div>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </>
                        );
                    })}

                <div className="w-14 px-2 flex absolute bottom-2 left-0  items-end select-none cursor-pointer z-50">
                    <div className="rounded-md w-full flex justify-center items-center flex-col">
                        <StateIcon></StateIcon>
                    </div>
                </div>
            </div>
        );
    }
}

const toolbarStateToProps = (state: RootState) => ({
    layout: state.layout.layout,
    switchs: state.layout.switchs,
    searchObject: state.layout.searchObject,
    highlightObject: state.layout.highlightObject,
    profileControls: state.layout.profileControls,
    mapControls: state.map.mapControls,
    mode: state.layout.mode,
    system: state.port.system,
    mainControls: state.layout.mainControls,
    menuControls: state.layout.menuControls,
    update: state.port.update,
    port: state.port.port,
    openModelFunction: state.layout.openModelFunction,
    user: state.user.user,
    pilotagePlanSettings: state.layout.pilotagePlanSettings,
    pilotagePlans: state.port.pilotagePlans,
    outlineInterval: state.map.outlineInterval,
    interfaceVariables: state.port.port?.meta_data.interfaceVariables,
});

const toolbarDispatchToProps = (dispatch: Dispatch) => ({
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
    showMessageAction: bindActionCreators(showMessageAction, dispatch),
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
});

export default connect(toolbarStateToProps, toolbarDispatchToProps)(ToolBar);
